// export const ApiEndpoint = "http://3.128.185.8:5001/api";
// export const ApiEndpoint = "http://3.18.212.245:5001/api";
// export const ApiEndpoint = "https://spm.cnexco.com/api/api"; // 本番
export const ApiEndpoint = "https://gis.cnexco.com/api/api"; // ミラー(ドメイン)
// export const ApiEndpoint = "https://gis.cnexco.com:3000/api/api"; // ミラー(Step2.5)
// export const ApiEndpoint = "https://18.222.55.225/api/api"; // ミラー(直IP)
// export const ApiEndpoint = "http://localhost:3001/api/api"; // Mockoon環境
// export const ApiEndpoint = "http://localhost:6001/api";  // ローカル（フロント・バック）環境
// export const ApiEndpoint = "https://sheltered-dawn-68271.herokuapp.com/http://18.191.112.47:5001/api";
// export const ApiEndpoint = "http://123.25.30.61:5002/api";
// export const ApiEndpoint = "https://localhost:6001/api";
// export const ApiEndpoint = "http://123.25.30.61:195/api/api";
